import { API } from "aws-amplify";
import moment from "moment";
import React from "react";
import {
  getAllDocumentTypes,
  documentTypeList,
  typeDocumentListAsContractors,
  familyRelationship,
  relationshipsKeys,
  genderKeys,
  relationships,
} from "./constants";

export const configConstants = {
  devTools: window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
};

export const getDocumentLabel = (id) => {
  const { name } = typeDocumentListAsContractors.find(
    (item) => item.value == id
  );
  return name;
};

export const getDocumentLabelRV = (id) => {
  const { name } = documentTypeList[id];
  return name;
};

export const MessageErrorsAuthAws = (code) => {
  if ("UserNotConfirmedException" === code) {
    return "Usuario requiere confirmación del registro antes de Loguear.";
  } else if ("PasswordResetRequiredException" === code) {
    return "Se requiere restablecer la contraseña.";
  } else if ("NotAuthorizedException" === code) {
    return "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar.";
  } else if ("UserNotFoundException" === code) {
    return "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar.";
  } else if ("InvalidPasswordException" == code) {
    return "El formato de contraseña es inválido.";
  } else {
    return "Ocurrió un error al autenticar. Contacte al administrador.";
  }
};

export const ValidateErrorsSecureInvestmentIncomeForm = (values) => {
  let err = {};

  if (/[0-9]{9}/.test(values.nroDoc)) err.nroDoc = "Debe contener 8 digitos";

  if (
    values.nroDoc.toString().length < 8 ||
    values.nroDoc.toString().length >= 9
  )
    err.nroDoc = "Debe contener 8 digitos";

  let capital = values.capital
    ? parseInt(values.capital.split(",").join(""))
    : null;

  if (values.nroDoc.toString().length == 0) err.nroDoc = "Campo requerido";

  // if (values.nameContractor == '')
  //   err.nameContractor = "Campo requerido";

  if (!capital) err.capital = "Campo Requerido";
  else if (values.money === "PEN" && capital < 100000)
    err.capital = "Prima Comercial: Prima debe ser mayor a S/100,000";
  else if (values.money === "USD" && capital < 30000)
    err.capital = "Prima Comercial: Prima debe ser mayor a $/30,000";

  if (!Number.isInteger(values.premiumRefund))
    err.premiumRefund = "Debe ingresar un número";
  else if (!(values.premiumRefund >= 0 && values.premiumRefund <= 100))
    err.premiumRefund = "La devolución de prima debe estar entre 0% y 100%";

  if (!Number.isInteger(values.cesion_comision))
    err.cesion_comision = "Debe ingresar un número";
  else if (!(values.cesion_comision >= 0 && values.cesion_comision <= 100))
    err.cesion_comision = "La cesión de comisión debe estar entre 0% y 100%";

  if (values.temporalYears * 12 < values.defermentMonths)
    err.defermentMonths =
      "El diferimiento no puede ser mayor a la temporalidad";

  return err;
};

export const ErrorMessage = ({ error, touched, disabledTouch }) => {
  if (error && touched)
    return <span className="message-error-form">{error}</span>;
  return null;
};

export const formatNumber = {
  separador: ",", // separador para los miles
  sepDecimal: ".", // separador para los decimales
  formatear: function (num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight =
      splitStr.length > 1
        ? this.sepDecimal + splitStr[1].padEnd(2, "0")
        : this.sepDecimal + "00";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return this.simbol + splitLeft + splitRight;
  },
  new: function (num, simbol) {
    this.simbol = simbol || "";
    return this.formatear(num);
  },
};

export const ValidateErrorsVas = (values, client) => {
  let err = {};

  if (!client) {
    let date = values.birthday_vas;

    let dateNow = moment().format("YYYY-MM-DD");
    let validateYearClient =
      parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) >= 18 &&
      parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) <= 79;

    if (values.typeDoc === "2") {
      if (/[0-9]{9}/.test(values.nroDoc))
        err.nroDoc = "Debe contener 8 digitos";

      if (values.nroDoc.toString().length < 8)
        err.nroDoc = "Debe contener 8 digitos";
    }
    if (values.typeDoc === "1") {
      if (/[0-9]{10}/.test(values.nroDoc))
        err.nroDoc = "Debe contener 9  digitos";

      if (values.nroDoc.toString().length < 9)
        err.nroDoc = "Debe contener 9 digitos";
    }
    let validateAgePresent =
      parseInt(dateNow.split("-")[0]) - parseInt(date.split("-")[0]) === 79;

    let validateDateOfAgeLimit =
      parseInt(dateNow.split("-")[1]) - parseInt(date.split("-")[1]) === 0 &&
      parseInt(dateNow.split("-")[2]) >= parseInt(date.split("-")[2]);

    if (values.name_contractor_vas === "")
      err.nameContractor = "Campo requerido";

    if (values.nroDoc === "") err.nroDoc = "Campo requerido";

    let capital = values.capital
      ? parseInt(values.capital.split(",").join(""))
      : null;

    if (!capital) err.capital = "Campo Requerido";
    else if (capital < 50000)
      err.capital = "Prima Comercial: Prima debe ser mayor a $50,000";

    if (
      !/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(
        date
      ) &&
      values.birthday_vas.length > 0
    )
      err.birthday_vas = "Ingrese una fecha valida";

    if (values.birthday_vas.length == 0) err.dateBirthday = "Campo requerido";

    let validatedateYear = parseInt(date.split("-")[0]) >= 1900;

    if (!validatedateYear && values.birthday_vas.length > 0)
      err.birthday_vas = "Ingrese una fecha valida en el rango de 18 a 79 años"; //"Ingrese una fecha valida";
    if (!validateYearClient && values.birthday_vas.length > 0)
      err.birthday_vas = "Ingrese una fecha valida en el rango de 18 a 79 años";
    if (validateAgePresent && validateDateOfAgeLimit)
      err.birthday_vas = "Ingrese una fecha menor a los 80 años";
    return err;
  }
};
export const ValidateErrorsInvesmentRVidaForm = (values) => {
  let err = {};
  if (values.typeDoc === "2") {
    if (/[0-9]{9}/.test(values.nroDoc)) err.nroDoc = "Debe contener 8 digitos";

    if (values.nroDoc.toString().length < 8)
      err.nroDoc = "Debe contener 8 digitos";
  }

  if (values.nameContractor === "") err.nameContractor = "Campo requerido";

  if (values.dateBirthday === "") err.dateBirthday = "Campo requerido";

  if (values.nroDoc === "") err.nroDoc = "Campo requerido";

  let capital = values.capital
    ? parseInt(values.capital.split(",").join(""))
    : null;

  if (!capital) err.capital = "Campo Requerido";
  else if (capital < 50000)
    err.capital = "Prima Comercial: Prima debe ser mayor a $50,000";
  return err;
};

export const getMonths = (values) => {
  let date = moment().format("YYYY-MM-DD");
  let f = '"23/04/2023"';
  let dateVto = parseInt(f.split("/")[2]);
  let totalMonths = (dateVto - parseInt(date.split("-")[0])) * 12;

  return totalMonths - parseInt(date.split("-")[1]) + parseInt(f.split("/")[1]);
};

export const typeDocument = {
  1: {
    valor: 1,
    nombre: "CE",
  },
  2: {
    valor: 2,
    nombre: "DNI",
  },
};

export const searchNameOfDocumentType = (value) => {
  if (value) {
    const { name } = getAllDocumentTypes.find((el) => el.value == value);
    return name;
  }
};

export const currency = {
  USD: {
    iso: "USD",
    simbolo: "$",
    nombre: "Dólares",
  },
  PEN: {
    iso: "PEN",
    simbolo: "S/",
    nombre: "Soles",
  },
};

export const getQuizIndexParent = (questions, index) => {
  let parent = questions[index].entityData.split(".");
  if (parent.length < 2) {
    return null;
  }
  parent = parent.slice(0, -1);
  parent = parent.join(".");
  const indexParent = questions.findIndex((item) => item.entityData === parent);
  return indexParent;
};

export const getYearsDaysMonth = (fecha) => {
  const arregloFecha = fecha.split("/");
  const birthYear = arregloFecha[2];
  const birthMonth = arregloFecha[1];
  const birthDay = arregloFecha[0];

  return `${birthYear}-${birthMonth}-${birthDay}`;
};

export const getConvertAssured = (assured) => {
  let asegurado = {};
  asegurado.tipoDocumento = assured.typeDoc;
  asegurado.apellidoPaterno = assured.firstName;
  asegurado.fechaNacimiento = assured.birthday;
  asegurado.numeroDocumento = assured.nroDoc;
  asegurado.sexo = assured.sexo;
  asegurado.apellidoMaterno = assured.lastName;
  asegurado.nombres = assured.names;
  asegurado.CC = assured.CC;
  asegurado.LPDP = assured.LPDP;
  asegurado.celular = assured.phone;
  asegurado.correo = assured.email;
  return asegurado;
};

export const getConvertContratant = (contratant) => {
  let contratante = {};
  contratante.tipoDocumento = contratant.typeDoc;
  contratante.apellidoPaterno = contratant.firstName;
  contratante.fechaNacimiento = contratant.birthday;
  contratante.numeroDocumento = contratant.nroDoc;
  contratante.sexo = contratant.sexo;
  contratante.apellidoMaterno = contratant.lastName;
  contratante.nombres = contratant.names;
  contratante.CC = contratant.CC;
  contratante.LPDP = contratant.LPDP;
  contratante.celular = contratant.phone;
  contratante.correo = contratant.email;
  return contratante;
};

export const getDataObtener = async (assured = [], contratant = []) => {
  const payload = {
    canalOrigen: "JOURNEY_INVERSION",
  };

  if (assured.length !== 0) {
    payload.asegurado = {};
    payload.asegurado.tipoDocumento = assured.typeDoc;
    payload.asegurado.apellidoPaterno = assured.firstName;
    payload.asegurado.fechaNacimiento = assured.birthday;
    payload.asegurado.numeroDocumento = assured.nroDoc;
    payload.asegurado.sexo = assured.sexo;
    payload.asegurado.apellidoMaterno = assured.lastName;
    payload.asegurado.nombres = assured.names;
    payload.asegurado.CC = assured.CC;
    payload.asegurado.LPDP = assured.LPDP;
    payload.asegurado.celular = assured.phone;
    payload.asegurado.correo = assured.email;
  }

  if (contratant.length !== 0) {
    payload.contratante = {};
    payload.contratante.tipoDocumento = contratant.typeDoc;
    payload.contratante.apellidoPaterno = contratant.firstName;
    payload.contratante.fechaNacimiento = contratant.birthday;
    payload.contratante.numeroDocumento = contratant.nroDoc;
    payload.contratante.sexo = contratant.sexo;
    payload.contratante.apellidoMaterno = contratant.lastName;
    payload.contratante.nombres = contratant.names;
    payload.contratante.CC = contratant.CC;
    payload.contratante.LPDP = contratant.LPDP;
    payload.contratante.celular = contratant.phone;
    payload.contratante.correo = contratant.email;
  }
  return await API.post("api-rentas", "/perfilamiento/obtener", {
    body: payload,
    headers: {},
  });
};

export const getPdfSimulacion = async (type, rowData) => {
  const idQuote = [];
  rowData.map((item) => {
    idQuote.push(item.idQuote);
  });
  const params = {
    producto: type,
    simulaciones: idQuote,
  };
  return await API.post("api-rentas", "/simulacion/generar-pdf", {
    body: params,
    headers: {},
  });
};

export const validateWatchList = async (nroDoc, typeDoc) => {
  const params = {
    tipoDocumento: typeDoc,
    numeroDocumento: nroDoc,
  };
  return await API.post("api-rentas", "/validate-watchlist", {
    body: params,
    headers: {},
  });
};

export const validateWatchListV2 = async (nroDoc, typeDoc, pep) => {
  const params = {
    tipoDocumento: typeDoc,
    numeroDocumento: nroDoc,
  };

  if (pep === "si") params.pep = true;
  if (pep === "no") params.pep = false;

  return await API.post("api-rentas", "/v2/validate-watchlist", {
    body: params,
    headers: {},
  });
};

export const handleState = (estado, widthREMPRO = 0) => {
  const TYPES = {
    Vencida: "Vencida",
    cancelada: "Cancelada",
    Vigente: "Vigente",
    pendiente: "Pendiente",
    emitida: "Emitida",
    rechazada: "Rechazada",
    vencida: "Vencida",
    vigente: "Vigente",
    enFila: "En fila",
    errEmitida: "Error al emitir",
    firmado: "Firmado",
    errPago: "Error de pago",
    ["Error de pago"]: "Error de pago",
    porFirmar: "Por firmar",
    ["Por firmar"]: "Por firmar",
    revision: "Revisión",
    suscrita: "Suscrita",
    enProceso: "En proceso",
    ingresado: "Ingresado",
    ingresadoRp: "Ingresado RP",
    cotizado: "Cotizado",
    mejorado: "Mejorado",
    enviadoMeller: "Env. Meller",
    ganado: "Ganado",
    perdido: "Perdido",
    recalculado: "Recalculado",
    cartaEnviada: "Carta Env.",
    datosActualizados: "Datos Act.",
    enviadoEmision: "Env. Emisión",
    errorCotizacion: "Error",
    aprobada: "Aprobada",
    ingresadoSRP: "Ingresado SRP",
    anulado: "Anulado",
  };

  const modifier =
    widthREMPRO == 0 ? TYPES[estado] || "-" : TYPES["ingresadoSRP"];
  return modifier;
};

export const mapToOptions = (array = []) => {
  if (array.length > 0) {
    return array.map((item) => {
      return {
        label: item.text || "",
        value: item.value || "",
      };
    });
  } else {
    return [];
  }
};

export const downloadXLSX = (file, name = "archivo") => {
  let fileName = `${name}.xlsx`;
  const binaryString = window.atob(file);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }

  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadXML = async (url, name = "archivo") => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error al descargar archivo: ${response.status}`);
    }
    
    const blob = await response.blob();
    
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.xml`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Error descargando XML:", error);
    throw error;
  }
};

export const camposOpcionalesBeneficiario = ["correoElectronico", "idTercero"];

export const transformDate = (date, isSpecial) => {
  if(isSpecial){
    return date.replaceAll("-", "/");
  }
  return moment(date).format("DD/MM/YYYY");
};

export const percentageFormat = (value) => {
  const isNumber = typeof value === "number";
  const numberValue = isNumber ? value : parseFloat(value);
  if (isNaN(numberValue)) return "";
  return (numberValue * 100).toFixed(2);
};

const keysParentsValue = {
  mom: 138,
  dad: 137,
}

export const relationshipFormatter = (value, gender) => {
  if(!value) return "";
  if(value === relationshipsKeys.PA) {
    return gender === genderKeys.F ? relationships[keysParentsValue.mom] : relationships[keysParentsValue.dad];
  }
  return familyRelationship[value] || "";
};
